const release = '0.11.5'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js